module.exports = __webpack_public_path__ + "media/images/flags/ie-9e3414e898f1a07d0bea10fed8d85084.svg";